import { render, staticRenderFns } from "./UserTasks.vue?vue&type=template&id=27e0b7a1&scoped=true"
import script from "./UserTasks.vue?vue&type=script&lang=ts"
export * from "./UserTasks.vue?vue&type=script&lang=ts"
import style0 from "./UserTasks.vue?vue&type=style&index=0&id=27e0b7a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e0b7a1",
  null
  
)

export default component.exports